import { useState } from 'react';
import { LONELINESS_OPTIONS, LONELINESS_QUESTIONS } from '@lessalone/shared';
import { submitCheckin } from '../lib/api';

/** The UCLA 3-item loneliness scale — three questions, scored 1–3 each. */
export function CheckinForm({
  checkpoint,
  onDone,
}: {
  checkpoint: 'intake' | 'ongoing';
  onDone: () => void;
}) {
  const [answers, setAnswers] = useState<(number | null)[]>([null, null, null]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const complete = answers.every((value) => value !== null);

  function choose(questionIndex: number, value: number) {
    setAnswers((prev) => prev.map((current, i) => (i === questionIndex ? value : current)));
  }

  async function submit() {
    const [a, b, c] = answers;
    if (a == null || b == null || c == null) return;
    setBusy(true);
    setError(null);
    const result = await submitCheckin(a, b, c, checkpoint);
    setBusy(false);
    if (result.ok) onDone();
    else setError(result.error);
  }

  return (
    <div className="stack">
      {LONELINESS_QUESTIONS.map((question, index) => (
        <fieldset key={question} className="checkin-q">
          <legend>{question}</legend>
          <div className="checkin-opts">
            {LONELINESS_OPTIONS.map((option) => (
              <label
                key={option.value}
                className={`checkin-opt${answers[index] === option.value ? ' on' : ''}`}
              >
                <input
                  type="radio"
                  name={`checkin-q${index}`}
                  checked={answers[index] === option.value}
                  onChange={() => choose(index, option.value)}
                />
                {option.label}
              </label>
            ))}
          </div>
        </fieldset>
      ))}
      <button type="button" disabled={!complete || busy} onClick={submit}>
        {busy ? 'Saving…' : 'Submit check-in'}
      </button>
      {error && <p className="error">{error}</p>}
    </div>
  );
}
